import PoolDevice from "./base";
import { DisplayProcessingLogics, StatesToDisplayItem } from "../Types";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import { DeviceTypes } from "../../config/documents/HardwareConfig";


export default class PoolDeviceThermistor extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static Icon = "temperature-sensor";
    static DeviceType = DeviceTypes.THERMISTOR;
    static PickerTitle = Locale.gettext("Thermistor");

    getDisplayNameTranslated(displayName:string) {
        switch (displayName) {
        case "Temperature": return Locale.gettext("Temperature");
        case "Temp": return Locale.gettext("Temp");
        default: return super.getDisplayNameTranslated(displayName);
        }
    }

    getMainMetricField(): StatesToDisplayItem {
        return ({
            Name: PoolsideDaemonDeviceStateNames.Temperature,
            DisplayName: "Temperature",
            DisplayNameShort: "Temp",
            DisplayOrder: 1,
            DisplayProcessingLogic: DisplayProcessingLogics.TEMP_F,
            DisplayProcessingLogicUnitAsDisplayName: true,
        });
    }
    
}


export enum PoolsideDaemonDeviceStateNames {
    Temperature = "Temperature"
}
    
